import { SVGProps } from 'react';

const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 11" {...props}>
        <path d="M7.727 9.59h-5V3.228h5m0-.909h-5a.91.91 0 0 0-.909.91V9.59a.909.909 0 0 0 .91.909h5a.91.91 0 0 0 .908-.91V3.228a.91.91 0 0 0-.909-.909ZM6.364.5H.909A.91.91 0 0 0 0 1.41v6.363h.91V1.409h5.454V.5Z" />
    </svg>
);
export default SvgCopy;
